module.exports = __webpack_public_path__ + "static/FaktSoftPro-Normal.c7d0206b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FaktSoftPro-Normal.woff
// module id = 493
// module chunks = 114276838955818